import React from 'react'
import Typed from "typed.js";
import { useEffect, useRef } from "react";
import signImg from "../assets/image/sign.svg"
export default function Home() {
    document.title = "Portfolio - HOME"
    // Create Ref element.
    const el = useRef(null);
    // const handleDownload = () => {
    //     const link = document.createElement('a');
    //     link.href = './pdf/CURRICULAM_VITAE_ADARSH.pdf'; // Set the path to your PDF file
    //     link.setAttribute('download', 'resume.pdf'); // Set the desired file name
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    // };
    useEffect(() => {
        const typed = new Typed(el.current, {
            strings: ["Programmer", "Web Developer"], // Strings to display
            // Speed settings, try diffrent values untill you get good results
            startDelay: 100,
            typeSpeed: 40,
            backSpeed: 10,
            backDelay: 2000,
            smartBackspace: true,
            loop: true,
            showCursor: true
        });

        // Destropying
        return () => {
            typed.destroy();
        };
    }, []);

    return (
        <section className="home-contents">
            <div className="left-side">
                <div>
                    <h1 className="slide">Hi, I'm <span>Adarsh Maurya <img src={signImg} alt='adarsh.png' loading="lazy" /></span></h1>
                    <h3 className="slide">I'm a <span ref={el}></span></h3>
                    <p className="slide">This is my official portfolio website to showcase my all works related to web
                        development.</p>
                    <a href="https://www.linkedin.com/in/adarshmaurya54">
                        <i className="fa-brands fa-linkedin slide"></i>
                    </a>
                    <a href="https://github.com/adarshmaurya54">
                        <i className="fa-brands fa-square-github slide"></i>
                    </a><br />
                    <a href="https://drive.google.com/file/d/179GwCd7RZfkgWkuH8h8Phpow4Iw3eFZi/view?usp=drive_link" className='cv resume slide'>DOWNLOAD CV</a>
                </div>
            </div>
        </section>
    )
}
